// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"557c82e6","447":"a472f575","456":"0c3cf412"}[chunkId] + ".css";
};